import Vue from "vue";
import MenuItem from "./components/MenuItem.vue";
import ChildMenuItem from "./components/ChildMenuItem.vue";
import HeadlinkMenuItem from "./components/HeadlinkMenuItem.vue";
import HeadlinkChildMenuItem from "./components/HeadlinkChildMenuItem.vue";
import Accordion from "./components/Accordion.vue";
import ContinuousScroller from "./components/ContinuousScroller.vue";
import VueTinySlider from 'vue-tiny-slider';
import VModal from "vue-js-modal";

Vue.use(VModal);

var app = new Vue({
  el: "#app",
  data: {
    mainMenuOpen: false,
    childMenuOpenID: 2,
    headLinkChildMenuOpenID: 0,
    animationTrigger: '',
  },
  components: {
    "menu-item": MenuItem,
    "child-menu-item": ChildMenuItem,
    accordion: Accordion,
    "vue-tiny-slider": VueTinySlider,
    "headlink-menu-item": HeadlinkMenuItem,
    "headlink-child-menu-item": HeadlinkChildMenuItem,
    "continuous-slider": ContinuousScroller,
  },
  methods: {
    toggleMainMenu: function () {
      this.mainMenuOpen = !this.mainMenuOpen;
      // if menu closed, close children as well
      if (!this.mainMenuOpen) {
        this.childMenuOpenID = 0;
      }
    },
    toggleChildMenu: function (childMenuOpenID) {
      // check if we're opening or closing menu
      if (this.childMenuOpenID === childMenuOpenID) {
        // close if is current open
        this.childMenuOpenID = 0;
      } else {
        this.childMenuOpenID = childMenuOpenID;
      }
      // open main menu if not open
      if (!this.mainMenuOpen) {
        this.mainMenuOpen = true;
      }
    },
    toggleHeadLinkChildMenu: function (headLinkChildMenuOpenID) {
      // check if we're opening or closing menu
      if (this.headLinkChildMenuOpenID === headLinkChildMenuOpenID) {
        // close if is current open
        this.headLinkChildMenuOpenID = 0;
      } else {
        this.headLinkChildMenuOpenID = headLinkChildMenuOpenID;
      }
    },
    showModal: function (name) {
      this.$modal.show(name);
    },
    hideModal: function (name) {
      this.$modal.hide(name);
    },
  },
});
